import { Box, Typography } from '@mui/material'

const VerifyEmail = () => {
  return (
    <Box
      display='flex'
      flexDirection='column'
      alignItems='center'
      justifyContent='center'
      minHeight='100vh'
      p={3}
    >
      <Typography variant='h5' gutterBottom>
        Verify your email
      </Typography>
      <Typography variant='body1' color='text.secondary'>
        Please check your inbox and verify your email address to continue.
      </Typography>
    </Box>
  )
}

export default VerifyEmail
